export const setProduct = (products: any) => ({
    type: 'SET_PRODUCTS',
    payload: products,
  });